module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/whatsappgroups.json
// module id = 1517
// module chunks = 162983165015478